import { Agenda } from './../../models/meeting-type-model.model';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { DataService } from '../../../../core/services/data.service';
import { Constants } from '../../constants';
import { GlobalConstants } from '../../global-constants';
import { SnackbarService } from '../../services/snackbar.service';
import { MeetingManagerService } from '../../../lib/services/meeting-manager.service';
import { CommonService } from '../../../lib/services/common.service';
import { Subscription } from 'rxjs';
import { ViewMeetingMapping } from '../../mapping/view-meeting-mapping';
import { ViewMeetingsDetail, ViewMinutesDetail } from '../../models/view-meeting.model';
import { SafeHtmlURLPipe } from '../../../../shared/common/pipes/safe-html.pipe';
import { SharedCommonService } from '../../../../shared/services/shared-common.service';
import { DialogConfig, DialogRef } from '@tylertech/forge-angular';
import { IDialogComponent, IMenuComponent, IMenuOption } from '@tylertech/forge';
import * as _ from 'lodash';
import { CreatePdfService } from "../../../../shared/services/create-pdf.service";

@Component({
    selector: 'appc-view-meeting',
    templateUrl: './view-meeting.component.html',
    styleUrls: ['./view-meeting.component.scss'],
    providers: [],
    standalone: false,
})
export class ViewMeetingComponent implements OnInit, OnDestroy, AfterViewInit {

    public meetingDetail: ViewMeetingsDetail;
    public isRecurring: Boolean = false;
    public fontColor: string;
    private subscriptions: Subscription = new Subscription();
    agendaStatus: any = {};
    backgroundColor = 'rgb(63, 81, 181)';
    minutesStatus: any = {};
    isDirect = false;
    isMeetingAvailable = true;
    isGettingMeeting = false;
    publicGoogleDisclosureUrl = '#/google-disclosure';

    /**
     * Creates an instance of ViewMeetingComponent.
     * @param
     * @memberof ViewMeetingComponent
     */
    constructor(
        public constants: Constants, // Services for Meeting Manager
        public globalConstants: GlobalConstants,
        public dataService: DataService,
        public snackbarService: SnackbarService, // Service used to display Notifications
        public meetingManagerService: MeetingManagerService,
        public commonService: CommonService,
        private viewMeetingMapping: ViewMeetingMapping,
        private sfeHTMl: SafeHtmlURLPipe,
        public sharedCommonService: SharedCommonService,
        public dialogConfig: DialogConfig,
        private dialogRef: DialogRef,
        private createPdfService: CreatePdfService
    ) {
        const data = this.dialogConfig.data;
        this.agendaStatus = this.constants.agendaItemStatus;
        this.minutesStatus = this.constants.minutesStatus;
        this.backgroundColor = data.backgroundColor;
        this.isDirect = data.isDirect;
    }

    /**
     * Angular ngOnInit lifecycle method
     */
    ngOnInit() {
        this.getMeeting();
    }

    ngAfterViewInit(): void {
        this.enhanceIconAccessibility();
    }

    enhanceIconAccessibility() {
        const iconElements = document.querySelectorAll('forge-icon');
        const dialogElements = document.querySelectorAll('forge-dialog');
        if(iconElements?.length){
          iconElements.forEach((icon)=> icon.setAttribute('aria-hidden', 'false'));
        }
        if(dialogElements?.length){
            dialogElements.forEach((icon)=> icon.setAttribute('aria-label', 'dialog'));
            dialogElements.forEach((icon)=> icon.setAttribute('aria-modal', 'false'));
          }
    }

    /**
     * Gets meeting Details based on Meeting and Recurring ID
     * @param
     * @memberof ViewMeetingComponent
     */
    getMeeting(): void {
        this.isGettingMeeting = true;
        const url = this.globalConstants.baseUrl + this.constants.serviceUrl.meeting.getMeeting;
        const noRepeat = this.constants.meetingConfig.meetingType.noRepeat;
        const params = {
            meetingId: Number(this.dialogConfig.data.meetingId),
            recurringId: Number(this.dialogConfig.data.recurringId),
            activity: 'View'
        };
        this.fontColor = this.commonService.getFontColor(this.dialogConfig.data.backgroundColor);
        this.subscriptions.add(this.dataService.post(url, params).subscribe(
            (response: any) => {
                this.isGettingMeeting = false;
                if (response) {
                    this.meetingDetail = this.viewMeetingMapping.getMeetingDetails(response);
                    this.backgroundColor = this.meetingDetail.colorHexCode;
                    this.fontColor = this.commonService.getFontColor(this.meetingDetail.colorHexCode);
                    this.meetingDetail.base64ThumbnailsString = this.sfeHTMl.transform(this.meetingDetail.base64ThumbnailsString);
                    this.meetingDetail.base64ThumbnailsStringForMinutes =
                        this.sfeHTMl.transform(this.meetingDetail.base64ThumbnailsStringForMinutes);
                    if (this.meetingDetail['adjourned'] === true) {
                        this.meetingDetail['meetingTitle'] = 'CANCELLED ' + this.meetingDetail['meetingTitle'];
                    }
                    if (this.meetingDetail.recurringType !== noRepeat) {
                        this.isRecurring = true;
                    }
                } else {
                    this.isMeetingAvailable = false;
                }
            }, (error: any) => {
                console.log(JSON.stringify(error));
                this.snackbarService.showMessage(this.constants.messages.error.internalServerError);
            }));
        
    }

    onClose(): void {
        this.dialogRef.close(this.isDirect);
    }

    navigatetoYoutube() {
        window.open(this.meetingDetail.uploadMinutesVideoURL, '_blank');
    }

    copyTextToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            this.snackbarService.showMessage(this.constants.messages.success.linkCopiedToClipboard);
        }).catch((error) => {
            this.snackbarService.showMessage(error);
        });
    }

    getMinutesShareMenuOptions(isPacket: boolean) {
        return this.globalConstants.baseUrl +
            this.constants.serviceUrl.shareableLink.minutesLink +
            isPacket + '/' + this.meetingDetail.minutesId;
    }

    getAgendaShareMenuOptions(isPacket: boolean) {
        return this.globalConstants.baseUrl +
            this.constants.serviceUrl.shareableLink.agendaLink +
            isPacket + '/' + this.meetingDetail.meetingAgendaId;
    }

    /**
    *Destorying the subscription
    *
    * @memberof AddAgendaItemComponent
    */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    toSetMoreOptions(isImported: boolean, menuComponent: IMenuComponent | null, shareMenuOptions: IMenuOption[], moreShareMenuOptions: IMenuOption[]) {
        if (menuComponent) {
            menuComponent.options = shareMenuOptions;
            if (!isImported) {
                menuComponent.options = moreShareMenuOptions
            }
        }
    }

    videoStatusAvailable(): boolean {
        return this.commonService.videoStatusAvailable(this.meetingDetail.videoStatus)
    }

}
